export { default } from 'common/enums/professional-situation.enum';
